import { createContext,useContext, useState, useEffect } from 'react';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendPasswordResetEmail,
  GoogleAuthProvider, 
  signInWithPopup,
  FacebookAuthProvider
  
} from 'firebase/auth'

import { auth } from "../firebase"

const AuthContext = createContext()
const provider = new GoogleAuthProvider()
const facebookProvider = new FacebookAuthProvider()


export function useAuth() {
    return useContext(AuthContext)
}

export function AuthProvider( {children}) {

  const [currentUser, setCurrentUser] = useState()
  const [currentAdmin, setCurrentAdmin] = useState()
  const [currentBecario, setCurrentBecario] = useState()

  const [loading,setLoading] = useState(true)

  function signup(email,password) {
    return createUserWithEmailAndPassword(auth,email,password)
  }

  function login(email,password) {
    return signInWithEmailAndPassword(auth,email,password)
  }

  function resetpassword(email) {
    return sendPasswordResetEmail(auth,email)
  }

  function logout() {
    return signOut(auth)
  }
  
 function googleSignIn(){    
    return signInWithPopup(auth,provider)
 }

 function facebookSignIn(){    
  return signInWithPopup(auth,facebookProvider)
}



  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth,user => {
      
      setCurrentUser(user);
      
      // Agregar propiedad de admin si el usuario es admin

      if (user){
        user.getIdTokenResult().then(idTokenResult =>{        
        user.admin = idTokenResult.claims.admin ? true : false;
        setCurrentAdmin(user.admin);

        user.becario = idTokenResult.claims.becario ? true : false;
        setCurrentBecario(user.becario);

        setCurrentUser(user);

        // console.log('admin',user.admin);
      })
    }
      setLoading(false);
    })

    return unsubscribe
    }, [])

//  Export functions
  const value  = {
    currentUser,
    currentAdmin,
    currentBecario,
    signup,
    login,
    resetpassword,
    logout,
    googleSignIn,
    facebookSignIn
    // createNote
  }

  return (
    <AuthContext.Provider value={value}>
        {!loading && children}
    </AuthContext.Provider>
  )
}
